import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

/** Custom Services */
import { SettingsService } from 'app/settings/settings.service';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { Cause, IngresoEgresoVariadoTemplateData, SavingsAccountTransctionTemplate } from 'app/model/savingsaccounttransctiontemplate';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckDetails } from 'app/model/checkdetails';
import { MatTableDataSource } from '@angular/material/table';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { Observable, Subscription } from 'rxjs';
import { OTPRequestData } from 'app/model/tillotp';
import { PaymentTypeOption } from 'app/model/loanrepaymenttemplate';
import { IngresoEgresoVarioServiceService } from '../ingreso-egreso-vario-service.service';

@Component({
  selector: 'mifosx-ingresos-egresos-varios',
  templateUrl: './ingresos-egresos-varios.component.html',
  styleUrls: ['./ingresos-egresos-varios.component.scss']
})
export class IngresosEgresosVariosComponent implements OnInit {

  readonly CASH_PAYMENT_TYPE = 1;
  readonly DOCUMENT_PAYMENT_TYPE = 2;
  selectedTeller: any;
  tellerSub: Subscription;
  labelButton: string = '';
  isDisabled: Boolean = false;

  causesOptions: Cause[];

  isDisabledPaymentType: Boolean = false;

  paymentTypeOptions: PaymentTypeOption[];
  showCheckDetailsView: Boolean = false;

  IngresoEgresoTransactionForm: FormGroup;
  /**
   * List of supported currencies
   */
  currencyOptions: SelectedCurrencyOptions;

  /** transaction type flag to render required UI */
  transactionType: { ingreso: boolean, egreso: boolean } = { ingreso: false, egreso: false };
  /** transaction command for submit request */
  transactionCommand: string = 'ingreso';
  /**
   * Check Details
   */

  ingresoEgresoTemplate: IngresoEgresoVariadoTemplateData;
  addCheckDetailsFlag: Boolean = false;
  checkForm: FormGroup;
  checkDetailsTable = new MatTableDataSource<CheckDetails>();
  checkDetails: Array<CheckDetails> = [];
  checkDetail: CheckDetails = {
    id: 0,
    checkAccountNumber: '',
    checkNumber: '',
    checkSecurityNumber: '',
    checkAmount: '',
    checkAmountToDeposit: '',
    targetName: '',
    countryCode: '',
    currencyCode: null,
    bankCode: '',
    locale: ''
  };

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private settingsService: SettingsService,
    private router: Router,
    private route: ActivatedRoute,
    private tellerGlobalService: TellerGlobalServiceService,
    private receiptService: ReceiptServiceService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper,
    private ingresoEgresoVarioService: IngresoEgresoVarioServiceService
  ) {


    this.transactionCommand = this.route.snapshot.params['name'].toLowerCase();
    this.transactionType[this.transactionCommand] = true;

  }

  ngOnInit(): void {
    this.ingresovarioForm();
    this.createCheckForm();

    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
    this.setTransactionType();
    this.chargeOptions();
  }

  setTransactionType() {
    if (this.transactionType.ingreso) {
      this.labelButton = 'Ingresar';
      this.isDisabledPaymentType = false;
      this.IngresoEgresoTransactionForm.controls['paymentTypeId'].setValue(1);
    } else if (this.transactionType.egreso) {
      this.labelButton = 'Retirar';
      this.isDisabledPaymentType = true;
      this.IngresoEgresoTransactionForm.controls['paymentTypeId'].setValue(1);
    }
  }

  chargeOptions() {

    this.route.data.subscribe(({ supportedCurrencies }) => {
      this.currencyOptions = supportedCurrencies;
    });
    this.setCauseOptions(this.transactionType.ingreso,this.CASH_PAYMENT_TYPE);
  }

  setCauseOptions(ingreso: boolean, paymentTypeId: number) {
    this.ingresoEgresoVarioService.getIngresoEgresoTemplate().subscribe((ingresoEgresoTemplate: IngresoEgresoVariadoTemplateData) => {
      this.ingresoEgresoTemplate = ingresoEgresoTemplate;
      if (this.ingresoEgresoTemplate?.causesOptions) {
        const operationType = ingreso ? 'C' : 'D';
        const isDocument = paymentTypeId === this.DOCUMENT_PAYMENT_TYPE;
        const isCashOperation = paymentTypeId === this.CASH_PAYMENT_TYPE;
        const currencyIntCode = this.currencyOptions.selectedCurrencyOptions[0].intCode;
        this.filterCauses(operationType, currencyIntCode, isDocument, isCashOperation);
      }
    });
  }


  ingresovarioForm() {
    this.IngresoEgresoTransactionForm = this.formBuilder.group({
      currencyCode: ['', Validators.required],
      transactionAmount: ['', Validators.required],
      paymentTypeId: ['', Validators.required],
      paymentCauseId: [''],
      note: ['']
    });
  }

  checkForEnableCheckOption() {
    const { operationType, selectedCurrencyIntCode, isDocument, isCashOperation } = this.determineFilterParameters();

    if (isDocument) {
      this.addCheckDetailsView();
    }

    this.filterCauses(operationType, selectedCurrencyIntCode, isDocument, isCashOperation);
  }


  addCheckDetailsView() {
      this.showCheckDetailsView = true;
  }

  addCheckDetails() {
    this.addCheckDetailsFlag = !this.addCheckDetailsFlag;
    if (this.addCheckDetailsFlag) {
      this.checkForm.addControl('checkAccountNumber', new FormControl(''));
      this.checkForm.addControl('chequeNumber', new FormControl(''));
      this.checkForm.addControl('checkSecurityNumber', new FormControl(''));
      this.checkForm.addControl('checkAmount', new FormControl(''));
      //this.checkForm.addControl('checkAmountTo', new FormControl(''));
      this.checkForm.addControl('targetName', new FormControl(''));
      this.checkForm.addControl('chequeCountry', new FormControl(1270));
      this.checkForm.addControl('chequeBank', new FormControl(''));
    } else {
      this.checkForm.removeControl('checkAccountNumber');
      this.checkForm.removeControl('chequeNumber');
      this.checkForm.removeControl('checkSecurityNumber');
      this.checkForm.removeControl('checkAmount');
      //this.checkForm.removeControl('checkAmountTo');
      this.checkForm.removeControl('targetName');
      this.checkForm.removeControl('chequeCountry');
      this.checkForm.removeControl('chequeBank');
    }
  }
  clearCheckFields() {
    this.checkForm.get('checkAccountNumber').setValue('');
    this.checkForm.get('chequeNumber').setValue('');
    this.checkForm.get('checkSecurityNumber').setValue('');
    this.checkForm.get('checkAmount').setValue('');
    //this.checkForm.get('checkAmountTo').setValue('');
    this.checkForm.get('targetName').setValue('');
    this.checkForm.get('chequeCountry').setValue(1270);
    this.checkForm.get('chequeBank').setValue('');
  }


  addNewCheck() {
    let checkData = {} as CheckDetails;
    checkData.id = this.checkDetails.length;
    checkData.checkAccountNumber = this.checkForm.get('checkAccountNumber').value;
    checkData.checkNumber = this.checkForm.get('chequeNumber').value;
    checkData.checkSecurityNumber = this.checkForm.get('checkSecurityNumber').value;
    checkData.checkAmount = this.checkForm.get('checkAmount').value;
    checkData.checkAmountToDeposit = this.checkForm.get('checkAmount').value;
    checkData.targetName = this.checkForm.get('targetName').value;
    checkData.countryCode = this.checkForm.get('chequeCountry').value;
    checkData.bankCode = this.checkForm.get('chequeBank').value;
    checkData.locale = this.settingsService.language.code;

    this.checkDetails.push(checkData);
    this.checkDetailsTable.data = this.checkDetails;
    this.clearCheckFields();
  }

  removeCheck(id: number) {
    this.checkDetails.splice(id, 1);
    this.checkDetailsTable.data = this.checkDetails;
  }

  createCheckForm() {
    this.checkForm = this.formBuilder.group({
    });
  }

  /**
   * Method to submit the form
   */
  submit() {
    if (this.IngresoEgresoTransactionForm.valid) {
      if (this.transactionType.ingreso) {
        this.realizarIngresoVario();
      } else if (this.transactionType.egreso) {
        this.realizarEgresoVario();
      }
    }
  }


  realizarIngresoVario() {
    this.isDisabled = true;
    const transactionData = this.getTransactionData('ingreso');
    this.ingresoEgresoVarioService.executeIngresoEgresoVarioCommand('ingreso', transactionData)
      .subscribe((response) => {
        if (response?.resourceId) {
          const transactionId = response.resourceId;
          this.receiptService.getTellerReport(this.selectedTeller['id'], `Caja_ingreso_vario`, transactionId, { transaction_id: transactionId }).subscribe(data =>
            this.dialogHelper.showDialog(data, this.matDialog, this.router, this.route));
        }
      }, error => {
        this.isDisabled = false;
      });
  }

  realizarEgresoVario() {
    this.isDisabled = true;
    const transactionData = this.getTransactionData('egreso');
    this.ingresoEgresoVarioService.executeIngresoEgresoVarioCommand('egreso', transactionData)
      .subscribe((response) => {
        if (response?.resourceId) {
          const transactionId = response.resourceId;
          this.receiptService.getTellerReport(this.selectedTeller['id'], `Caja_egreso_vario`, transactionId, { transaction_id: transactionId }).subscribe(data =>
            this.dialogHelper.showDialog(data, this.matDialog, this.router, this.route));
        }
      }, error => {
        this.isDisabled = false;
      });
  }

  private getTransactionData(type: string) {
    const dateFormat = this.settingsService.dateFormat;
    const locale = this.settingsService.language.code;
    const tellerId = this.selectedTeller?.id;

    const transactionData = {
      ...this.IngresoEgresoTransactionForm.value,
      transactionDate: this.datePipe.transform(new Date(), dateFormat),
      locale,
      dateFormat,
      channel: 'caja',
      tellerId
    };

    if (this.checkDetails.length > 0) {
      const txnCurrency = this.currencyOptions.selectedCurrencyOptions
        .find((currency) => currency.code === transactionData.currencyCode);


      this.checkDetails.forEach((check) => {
        check.currencyCode = txnCurrency.intCode;
      });

      transactionData.checksDetails = this.checkDetails;
    }

    if (type === 'ingreso') {
      transactionData.type = 'INGRESO';
    } else if (type === 'egreso') {
      transactionData.type = 'EGRESO';
    }

    return transactionData;
  }

  selectCurrencyEvent() {
    const { operationType, selectedCurrencyIntCode, isDocument, isCashOperation } = this.determineFilterParameters();
    this.filterCauses(operationType, selectedCurrencyIntCode, isDocument, isCashOperation);
  }



  filterCauses(operationType?: string, currencyIntCode?: number, isDocument?: boolean, isCashOperation?: boolean) {
    this.causesOptions = this.ingresoEgresoTemplate.causesOptions.filter((cause) => {
      let matchesOperationType = true;
      let matchesCurrencyCode = true;
      let matchesDocument = true;
      let matchesCash = true;
  
      if (operationType) {
        matchesOperationType = cause.operationType === operationType;
      }
  
      if (currencyIntCode) {
        matchesCurrencyCode = cause.currencyCode === currencyIntCode;
      }
  
      if (isDocument !== undefined) {
        matchesDocument = cause.isDocument === isDocument;
      } 

      if (isCashOperation !== undefined) {
      matchesCash = cause.isCashOperation === isCashOperation;
      }
      return matchesOperationType && matchesCash && matchesDocument && matchesCurrencyCode;
    });
  }
  

  determineFilterParameters() {
    const isPaymentTypeValid = this.IngresoEgresoTransactionForm.get('paymentTypeId').valid;
    let paymentTypeId:number = null;

    if (isPaymentTypeValid) {
      paymentTypeId = this.IngresoEgresoTransactionForm.get('paymentTypeId').value;
    }else{
      paymentTypeId = this.CASH_PAYMENT_TYPE;
    }

    const isDocument = paymentTypeId === this.DOCUMENT_PAYMENT_TYPE;
    const isCashOperation = paymentTypeId === this.CASH_PAYMENT_TYPE;
    const operationType = this.transactionType.ingreso ? 'C' : 'D';
    const isCurrencySelected = this.IngresoEgresoTransactionForm.get('currencyCode').valid;

    let selectedCurrencyIntCode: number = null;

    if (isCurrencySelected) {
      const currencySelected = this.IngresoEgresoTransactionForm.get('currencyCode').value;
      selectedCurrencyIntCode = this.currencyOptions.selectedCurrencyOptions.find(currency => currency.code === currencySelected)?.intCode;
    }
    return { operationType, selectedCurrencyIntCode, isDocument, isCashOperation };
  }

}

